import { spaceCadet } from '@cogneed/react-utils';
import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  border: `1px solid ${spaceCadet[300]}`,
  padding: 8,
  borderRadius: 4,
  '& .MuiBox-root.cta': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& > .MuiButton-root': {
      textTransform: 'none',
    },
    '& > .MuiTypography-body1': {
      fontSize: 14,
    },
  },
  '& > .MuiTypography-subtitle1': {
    color: spaceCadet[400],
    fontWeight: 600,
    textTransform: 'uppercase',
    lineHeight: '24px',
    fontSize: 14,
  },
  '& > .MuiBox-root': {
    '& .markdown': {
      fontSize: 14,
      lineHeight: '24px',
    },
    '& > .MuiButton-containedSizeSmall': {
      padding: '8px',
      fontSize: 14,
      gap: 4,
      '& .MuiSvgIcon-root': {
        fontSize: 16,
      },
    },
  },
});

export default StyledBox;
